import { FC, ReactNode, useMemo } from 'react'

import { MapContext } from './MapContext.js'

type Props = {
  apiKey: string
  nonce?: string
  children: ReactNode
}

export const MapProvider: FC<Props> = ({ apiKey, nonce, children }) => {
  const value = useMemo(
    () => ({
      apiKey,
      nonce,
    }),
    [apiKey, nonce]
  )

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>
}
